<template>
  <el-card shadow="never" class="ymd_card sbu">
    <div slot="header" v-if="title">
      <h4>{{ title }}</h4>
    </div>
    <div>
      <el-form :label-width="labelWidth" :label-position="labelPosition">
        <el-form-item label="Date" class="item">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="-"
            start-placeholder="StartDate"
            end-placeholder="EndDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    title: String,
    labelWidth: {
      type: String,
      default: "80px",
    },
    labelPosition: {
      type: String,
      default: "left",
    },
  },
  data() {
    return {
      time: "",
    };
  },
  watch: {
    time: {
      handler() {
        let data = {};
        if (this.time && this.time.length > 0) {
          data = {
            startTimeStr: this.time[0],
            endTimeStr: this.time[1],
          };
        }
        this.$emit("change", data);
      },
    },
  },
};
</script>
<style >
.ymd_card .el-form-item__label {
  font-weight: 600;
}
</style>
<style scoped>
.item {
  margin-bottom: 0;
}
.ymd_card {
  height: 100%;
}
</style>